import { render, staticRenderFns } from "./ExamHeader.vue?vue&type=template&id=a16203c6&scoped=true&"
import script from "./ExamHeader.vue?vue&type=script&lang=js&"
export * from "./ExamHeader.vue?vue&type=script&lang=js&"
import style0 from "./ExamHeader.vue?vue&type=style&index=0&id=a16203c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16203c6",
  null
  
)

export default component.exports